<div fxLayoutAlign="center center">
  <button  mat-raised-button color="warn"
          (click)="deleteMonitor()" class="btn-delete-monitor">
    {{'GENERAL.DELETE' | translate}}
  </button>
</div>
